import { Commit } from 'vuex';

interface CommitFunction {
  commit: Commit;
}

interface State{
    createdGame: string;
    playViewFocus: boolean;
}

export const game = {
    namespaced: true,
    state: {
        createdGame: sessionStorage.getItem("createdGame") ? sessionStorage.getItem("createdGame") : '',
        playViewFocus: sessionStorage.getItem("playViewFocus")? JSON.parse(sessionStorage.getItem("playViewFocus")) : false,
    },

    getters: {
        createdGame(state: State): string {
            return state.createdGame;
        },
        isPlayViewFocus(state:State):boolean{
            return state.playViewFocus;
        },
    },

    mutations: {
        SET_CREATED_GAME(state: State, value: string): void {
            sessionStorage.setItem("createdGame", value);
            state.createdGame = value;
        },

        SET_PLAY_VIEW_FOCUS (state:State):void{
            sessionStorage.setItem("playViewFocus", JSON.stringify(true));
            state.playViewFocus = true;
        },
      
        SET_PLAY_VIEW_BLUR (state:State):void{
            sessionStorage.setItem("playViewFocus", JSON.stringify(false));
            state.playViewFocus = false;
        },
    },

    actions: {
        addGame: ({commit}, value: string): void => {
            commit('SET_CREATED_GAME', value);
        },

        playViewIsFocus: ({commit}: CommitFunction):void => {
            commit('SET_PLAY_VIEW_FOCUS');
          },

          playViewIsBlur: ({commit}: CommitFunction):void => {
            commit('SET_PLAY_VIEW_BLUR');
          },
    }
}